module.exports = __webpack_public_path__ + "static/media/4850.04bd6e7e.jpg";